// extracted by mini-css-extract-plugin
export default {"root":"mxyzk7","authorRole":"pO2fHm"};